import React from 'react';

import { SVGComponentProps } from './svg.types';

const WarningSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <g clipPath="url(#clip0_4978_14031)">
          <path
            d="M13.8196 11.1123L8.07705 1.58873C7.85081 1.21355 7.43811 0.980469 6.99998 0.980469C6.56186 0.980469 6.14916 1.21355 5.92289 1.58876L0.180344 11.1123C-0.0534723 11.5001 -0.0603903 11.986 0.16227 12.3803C0.384985 12.7746 0.804602 13.0195 1.25741 13.0195H12.7426C13.1954 13.0195 13.615 12.7746 13.8377 12.3802C14.0604 11.9859 14.0535 11.5001 13.8196 11.1123ZM13.044 11.9321C12.9827 12.0406 12.8672 12.108 12.7426 12.108H1.25741C1.13275 12.108 1.01723 12.0406 0.955949 11.9321C0.894645 11.8235 0.896559 11.6898 0.960899 11.583L6.7035 2.05943C6.76579 1.95615 6.8794 1.89197 7.00001 1.89197C7.1206 1.89197 7.23421 1.95615 7.2965 2.05943L13.039 11.583C13.1034 11.6898 13.1054 11.8235 13.044 11.9321Z"
            fill={fill}
          />
          <path
            d="M7.00403 4.73047C6.65731 4.73047 6.38672 4.91652 6.38672 5.24634C6.38672 6.25264 6.50509 7.69869 6.50509 8.70502C6.50512 8.96716 6.73346 9.07709 7.00406 9.07709C7.207 9.07709 7.49452 8.96716 7.49452 8.70502C7.49452 7.69871 7.61289 6.25267 7.61289 5.24634C7.61289 4.91654 7.33385 4.73047 7.00403 4.73047Z"
            fill={fill}
          />
          <path
            d="M7.01249 9.66064C6.64043 9.66064 6.36133 9.95661 6.36133 10.3118C6.36133 10.6585 6.6404 10.963 7.01249 10.963C7.35921 10.963 7.65521 10.6585 7.65521 10.3118C7.65521 9.95661 7.35918 9.66064 7.01249 9.66064Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_4978_14031">
            <rect width={size} height={size} fill={fill} />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default WarningSVG;
